import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './delete-account.style';

export type DeleteAccountConfirmProps = {
  onSubmit: () => void;
  onCancel: () => void;
};

export const DeleteAccountConfirm: React.FC<DeleteAccountConfirmProps> = ({
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t('dialogs.delete-account.confirm.title')}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">
          {t('dialogs.delete-account.confirm.description')}
        </Typography>
        <Typography variant="body2">
          {t('dialogs.delete-account.confirm.warning')}
        </Typography>
      </Styled.Body>

      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          color={Colors.Inherit}
          onClick={onCancel}
        >
          {t('dialogs.delete-account.confirm.button.cancel')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onSubmit}>
          {t('dialogs.delete-account.confirm.button.submit')}
        </Button>
      </Styled.Interactions>
    </>
  );
};
